import { Component, OnInit } from '@angular/core';
import { IUsersystem } from '../interfaces/usersystem';

import { OperadorService } from '../services/operador.service';

import { faStream, faSlidersH } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
  host: { class: 'wrapper-settings' },
})
export class SettingsComponent implements OnInit {
  public isMatriz: boolean = false;
  public operador: IUsersystem;

  public faStream = faStream;
  public faSlidersH = faSlidersH;

  constructor(private _operadorService: OperadorService) {
    this.operador = this._operadorService.getOperador();

    if (this.operador.estabelecimento)
      this.isMatriz = this.operador.estabelecimento['matriz'] == 'S';
  }

  ngOnInit(): void {}
}
